async function openquickview(event) {
  event.preventDefault();

  const button = event.currentTarget;
  const productId = button.getAttribute("data-product-id");
  const productHandle = button.getAttribute("data-product-handle");

  if (!productHandle) {
    console.warn("No product handle found on button!");
    return;
  }

  const drawer = document.getElementById("quick-add-drawer");
  const content = document.getElementById("drawer-product-content");

  // Show loading state
  content.innerHTML = "<p>Loading...</p>";

  // try {
  //   // Fetch product JSON by handle
  //   const response = await fetch(`/products/${productHandle}.js`);
  //   if (!response.ok) throw new Error("Failed to fetch product data");

  //   const product = await response.json();

  //   // Example: Replace this with your desired markup
  //   content.innerHTML = `
  //       <h2>${product.title}</h2>
  //       <img src="${product.images[0]}" alt="${
  //     product.title
  //   }" style="max-width:100%;">
  //       <p>Price: $${(product.price / 100).toFixed(2)}</p>
  //       <p>${product.description}</p>
  //     `;

  //   drawer.classList.remove("hidden");

  //   // Add ?quickview=id to URL
  //   const url = new URL(window.location);
  //   url.searchParams.set("quickview", productId);
  //   window.history.pushState({}, "", url);
  // } catch (error) {
  //   console.error("Error fetching product:", error);
  //   content.innerHTML = "<p>Failed to load product.</p>";
  // }
}

// Close drawer logic
document.querySelectorAll("[data-close-drawer]").forEach((el) => {
  el.addEventListener("click", () => {
    document.getElementById("quick-add-drawer").classList.add("hidden");

    const url = new URL(window.location);
    url.searchParams.delete("quickview");
    window.history.pushState({}, "", url);
  });
});

// Optional: Open drawer on page load if param exists
document.addEventListener("DOMContentLoaded", async () => {
  const params = new URLSearchParams(window.location.search);
  const productId = params.get("quickview");

  if (productId) {
    // You’ll need to map product ID to handle for fetching
    // Easiest: put product handle in the query param instead
    console.warn("This example expects handle for fetching!");
  }
});
